import React from 'react'
import './ProfileIDTripOrgFeedBack.css';
import { useLocation } from 'react-router-dom';

const ProfileIDTripOrgFeedBack = () => {
    const location = useLocation()
    const orgprofile = location.state.orgprofile
    const organiserId = location?.state?.organiserId?.profile_id
    const reviewAsUser = location?.state?.reviewAsUser
    console.log('reviewAsUser :', reviewAsUser)
    console.log('organiser   from feedback :', orgprofile);
    const sumOfRatings = orgprofile.reduce((sum, eachOrgRating) => {
        return sum + eachOrgRating.organiser_rating;
    }, 0);
    const averageOrgRating = (sumOfRatings / orgprofile.length).toFixed(2);
    console.log('org rating :', averageOrgRating)


    return (
        <div>
            <div className="event-information-container">

                <div className="details-container">
                    <div className="details-content-container">
                        <h5 className="information-side-top-heading">Profile ID</h5>
                        <p className="information-content">{organiserId}</p>
                    </div>
                    <div className="details-content-container">
                        <h5 className="information-side-top-heading">Event Status</h5>
                        <p className="information-content"> Trip Organsier </p>
                    </div>
                    <div className="details-content-container">
                        <h5 className="information-side-top-heading">Full Name</h5>
                        <p className="information-content">
                            {orgprofile[0]?.feedback_event_id?.organizers}
                        </p>
                    </div>
                    <div className="details-content-container">
                        <h5 className="information-side-top-heading">Overall organiser rating</h5>
                        <p className="information-content">{averageOrgRating} </p>
                    </div>

                </div>
            </div>
            <br></br>
            <p className="upcomingsession-text">Total Reviews received ({orgprofile.length})</p>
            {orgprofile.map((eachEvent, index) => (
                <div key={index}>
                    <div className="details-container">
                        <div className="details-content-container">
                            <h5 className="information-side-no">{index + 1}</h5>
                            <h5 className="information-side-heading">Event ID</h5>
                            <p className="information-content1">{eachEvent?.feedback_event_id?.ID_event}</p>
                        </div>
                        <div className="details-content-container">
                            <h5 className="information-side-heading">Event title</h5>
                            <p className="information-content">
                                {eachEvent?.feedback_event_id?.trip_title}

                            </p>
                        </div>
                        <div className="details-content-container">

                            <h5 className="information-side-heading">Event date</h5>
                            <p className="information-content1">{eachEvent?.feedback_event_id?.start_date}</p>
                        </div>
                        <div className="details-content-container">
                            <h5 className="information-side-heading">Reviewer ID</h5>
                            <p className="information-content1">{eachEvent?.feedback_user_id?.profile_id}</p>
                        </div>
                        <div className="details-content-container">
                            <h5 className="information-side-heading">Reviewer Full Name</h5>
                            <p className="information-content1">{eachEvent?.feedback_user_id?.firstName} {eachEvent?.feedback_user_id?.lastName}</p>
                        </div>
                        <div className="details-content-container">
                            <h5 className="information-side-heading">Overall  rating</h5>
                            <p className="information-content">{eachEvent.event_rating}</p>
                        </div>
                        <div className="details-content-container">

                            <h5 className="information-side-heading">Organiser rating</h5>
                            <p className="information-content">{eachEvent.organiser_rating}</p>
                        </div>
                        <div className="details-content-container">

                            <h5 className="information-side-heading">Mosted Enjoyed</h5>
                            <p className="information-content">       {eachEvent?.event_review.join(",  ") || 'Null'} </p>
                        </div>
                        <div className="details-content-container">

                            <h5 className="information-side-heading">Areas to improve</h5>
                            <p className="information-content">{eachEvent?.mbt_experience?.join(",  ") || 'Null'}</p>
                        </div>
                        <div className="details-content-container">

                            <h5 className="information-side-heading">Organiser review</h5>
                            <p className="information-content">
                                {eachEvent?.organiser_review.join(" ") || 'Null'}
                            </p>
                        </div>
                        <div className="details-content-container">
                            <h5 className="information-side-heading">Suggestions</h5>
                            <p className="information-content">
                                {eachEvent?.suggestions || 'Null'}
                            </p>
                        </div>
                        <div className="details-content-container">
                            <h5 className="information-side-heading">Join more trips </h5>
                            <p className="information-content"> {eachEvent?.join_more_trips || 'Null'}</p>
                        </div>
                    </div>
                    <br></br></div>
            ))}

            <br></br>

            {reviewAsUser.map((eachEvent) => (
                <div>

                    <p className="upcomingsession-text">Total Reviews given({reviewAsUser.length})</p>
                    <br></br>
                    <div className="details-container">
                        <div className="details-content-container">
                            <h5 className="information-side-no">1</h5>
                            <h5 className="information-side-heading">Event ID</h5>
                            <p className="information-content1">{eachEvent?.feedback_event_id?.ID_event}</p>
                        </div>
                        <div className="details-content-container">
                            <h5 className="information-side-heading">Event title</h5>
                            <p className="information-content">{eachEvent?.feedback_event_id?.trip_title}</p>
                        </div>
                        <div className="details-content-container">
                            <h5 className="information-side-heading">Event date</h5>
                            <p className="information-content1">{eachEvent?.feedback_event_id?.start_date}</p>
                        </div>
                        <div className="details-content-container">
                            <h5 className="information-side-heading">Overall rating</h5>
                            <p className="information-content">{eachEvent?.event_rating}</p>
                        </div>
                        <div className="details-content-container">
                            <h5 className="information-side-heading">Organiser rating</h5>
                            <p className="information-content">{eachEvent?.organiser_rating}</p>
                        </div>
                        <div className="details-content-container">
                            <h5 className="information-side-heading">Mosted Enjoyed</h5>
                            <p className="information-content">{eachEvent?.event_review.join(",  ") || 'Null'}</p>
                        </div>
                        <div className="details-content-container">
                            <h5 className="information-side-heading">Areas to improve</h5>
                            <p className="information-content">{eachEvent?.mbt_experience?.join(",  ") || 'Null'}</p>
                        </div>
                        <div className="details-content-container">
                            <h5 className="information-side-heading">Organiser review</h5>
                            <p className="information-content">
                                {eachEvent?.organiser_review.join(" ") || 'Null'}
                            </p>
                        </div>
                        <div className="details-content-container">
                            <h5 className="information-side-heading">Suggestions</h5>
                            <p className="information-content">
                                {eachEvent?.suggestions || 'Null'}
                            </p>
                        </div>
                        <div className="details-content-container">
                            <h5 className="information-side-heading">Join more trips </h5>
                            <p className="information-content">{eachEvent?.join_more_trips || 'Null'}</p>
                        </div>
                    </div>
                </div>
            ))}

        </div>
    )
}

export default ProfileIDTripOrgFeedBack
